import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API_URL from "../../../../apiConfig";
import AdminHeader from "../../../../components/AdminHeader";
import AdminPageHeader from "../../../../components/admin/AdminPageHeader";
import apiFetch from "../../../../utils/apiFetch";

export default function AdminSections() {

  const { systemId } = useParams();

  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(true);

  async function loadSections() {
    try {
      const data = await apiFetch(`/api/systems/${systemId}/sections`);
      setSections(data.sections || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadSections();
  }, []);

  async function createSection(e) {
    e.preventDefault();

    try {
      const json = await apiFetch(`/api/systems/${systemId}/sections`, {
        method: "POST",
        body: { title, description },
      });

      setTitle("");
      setDescription("");

      loadSections();

    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  }

  async function removeSection(id) {
    if (!window.confirm("¿Eliminar sección?")) return;

    try {
      await apiFetch(`/api/systems/${systemId}/sections/${id}`, {
        method: "DELETE",
      });

      loadSections();

    } catch (err) {
      console.error(err);
    }
  }

  if (loading) return <div style={{ padding: 40 }}>Cargando...</div>;

  return (
    <>
      <AdminHeader />

      <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>

        <AdminPageHeader
          title="Secciones"
          subtitle="Organizar las secciones del sistema."
          backTo="/admin/systems"
        />

        {/* FORM */}
        <form onSubmit={createSection} style={formBox}>

          <input
            placeholder="Título de la sección"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={inputStyle}
          />

          <textarea
            placeholder="Descripción (opcional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={inputStyle}
          />

          <button style={primaryBtn}>
            Crear sección
          </button>

        </form>

        {/* LISTADO */}
        <div style={{ marginTop: 20, display: "grid", gap: 12 }}>

          {sections.length === 0 ? (
            <p style={{ color: "#6b7a88" }}>No hay secciones aún.</p>
          ) : (
            sections.map((s) => (
              <div key={s.id} style={cardStyle}>

                <div>
                  <div style={titleStyle}>{s.title}</div>
                  <div style={slugStyle}>{s.slug}</div>
                </div>

                <div style={actionsStyle}>

                  <Link
                    to={`/admin/systems/${systemId}/sections/${s.id}/lessons`}
                    style={linkStyle}
                  >
                    Días →
                  </Link>

                  <button
                    onClick={() => removeSection(s.id)}
                    style={deleteBtn}
                  >
                    Eliminar
                  </button>

                </div>

              </div>
            ))
          )}

        </div>

      </div>
    </>
  );
}

/* ===== STYLES ===== */

const formBox = {
  display: "grid",
  gap: 10,
  padding: 20,
  borderRadius: 12,
  border: "1px solid #e6ebf1",
  background: "#fff",
  marginBottom: 20
};

const inputStyle = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid #ddd"
};

const primaryBtn = {
  padding: "10px 14px",
  background: "#0a2230",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600
};

const cardStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: 14,
  borderRadius: 10,
  border: "1px solid #e6ebf1",
  background: "#fff"
};

const titleStyle = {
  fontWeight: 600
};

const slugStyle = {
  fontSize: 12,
  color: "#9ca3af",
  marginTop: 2
};

const actionsStyle = {
  display: "flex",
  gap: 10,
  alignItems: "center"
};

const linkStyle = {
  textDecoration: "none",
  color: "#286b94",
  fontWeight: 600
};

const deleteBtn = {
  border: "1px solid #ddd",
  padding: "6px 10px",
  borderRadius: 6,
  background: "#fff",
  cursor: "pointer"
};